import React from "react";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import MaterialTabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component="span">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function Tabs({ tabsLabel, tabsContent }) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Grid item xs={12}>
      <Grid container>
        <AppBar position="static" color="transparent" elevation={0}>
          <MaterialTabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="on"
            aria-label="scrollable auto tabs example"
          >
            {tabsLabel?.map((label, index) => (
              <Tab key={index} label={label} />
            ))}
          </MaterialTabs>
        </AppBar>
      </Grid>
      {tabsContent?.map((content, index) => (
        <Grid container key={index}>
          <TabPanel key={index} value={value} index={index}>
            {content}
          </TabPanel>
        </Grid>
      ))}
    </Grid>
  );
}

Tabs.propTypes = {
  /**
   * Lista dos nomes das abas que serão exibidas. É importante que o tamanho da lista seja igual o tamanho da lista da prop tabsContent
   */
  tabsLabel: PropTypes.array,
  /**
   * Lista dos conteudos das abas que serão exibidas. É importante que o tamanho da lista seja igual o tamanho da lista da prop tabsLabel
   */
  tabsContent: PropTypes.array,
};

export default Tabs;
